import React, { useState, useEffect } from 'react';

export default function ThinkyIOTNotifications({ onBack }) {
  const [notifications, setNotifications] = useState([
    { id: 1, device: 'Device A', type: 'Temperature Alert', status: 'Active', time: '09:15 AM' },
    { id: 2, device: 'Device B', type: 'Battery Low', status: 'Resolved', time: '09:45 AM' },
    { id: 3, device: 'Device C', type: 'Offline', status: 'Active', time: '10:05 AM' },
  ]);

  useEffect(() => {
    // Simulate incoming notifications
    const interval = setInterval(() => {
      const newNotification = {
        id: notifications.length + 1,
        device: `Device ${String.fromCharCode(65 + Math.floor(Math.random()*3))}`,
        type: ['Temperature Alert', 'Battery Low', 'Offline'][Math.floor(Math.random()*3)],
        status: ['Active', 'Resolved'][Math.floor(Math.random()*2)],
        time: new Date().toLocaleTimeString(),
      };
      setNotifications(prev => [newNotification, ...prev.slice(0, 9)]);
    }, 5000);

    return () => clearInterval(interval);
  }, [notifications]);

  return (
    <div className="min-h-screen bg-black text-white px-4 py-8">
      <button onClick={onBack} className="mb-6 px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 w-24">&larr; Back</button>
      <h1 className="text-lg lg:text-xl font-bold mb-6">Alarms & Notifications</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {notifications.map(n => (
          <div key={n.id} className={`bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm`}> 
            <h3 className="text-lg font-semibold mb-2">{n.device}</h3>
            <p>Type: <span className="text-blue-400 font-medium">{n.type}</span></p>
            <p>Status: <span className={`${n.status === 'Active' ? 'text-red-500' : 'text-green-400'} font-semibold`}>{n.status}</span></p>
            <p>Time: {n.time}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
